import { RefObject } from "react";

type ScrollSource = RefObject<"manual" | "menu"> | null;
type TimeoutRef = RefObject<NodeJS.Timeout | null> | null;
type SetActiveSection = ((section: string) => void) | null;

interface SmoothScrollOptions {
  scrollSource?: ScrollSource;
  menuScrollTimeout?: TimeoutRef;
  setActiveSection?: SetActiveSection;
  offset?: number;
  delay?: number;
  scrollDuration?: number;
}

export const smoothScrollToSection = (
  targetId: string,
  preloadSectionsUntil: (sectionId: string) => void,
  options: SmoothScrollOptions = {}
) => {
  const {
    scrollSource = null,
    menuScrollTimeout = null,
    setActiveSection = null,
    offset = 60,
    delay = 100,
    scrollDuration = 1000,
  } = options;

  preloadSectionsUntil(targetId);

  setTimeout(() => {
    const element = document.getElementById(targetId);
    if (element) {
      if (scrollSource?.current) {
        (scrollSource.current as "manual" | "menu") = "menu";
      }

      if (menuScrollTimeout?.current) {
        clearTimeout(menuScrollTimeout.current);
      }

      const elementOffset = element.offsetTop || 0;

      window.scrollTo({
        top: elementOffset - offset,
        behavior: "smooth",
      });

      if (setActiveSection) {
        setActiveSection(targetId);
      }

      if (scrollSource && menuScrollTimeout) {
        (menuScrollTimeout as { current: NodeJS.Timeout | null }).current = setTimeout(() => {
          if (scrollSource.current) {
            (scrollSource.current as "manual" | "menu") = "manual";
          }
        }, scrollDuration);
      }
    }
  }, delay);
};

export const handleSectionClick = (
  e: React.MouseEvent<HTMLAnchorElement>,
  href: string,
  preloadSectionsUntil: (sectionId: string) => void,
  options: SmoothScrollOptions = {}
) => {
  e.preventDefault();
  const targetId = href.substring(1);
  smoothScrollToSection(targetId, preloadSectionsUntil, options);
};
